import { render, staticRenderFns } from "./DesignPage.vue?vue&type=template&id=75b00e04&scoped=true&"
import script from "./DesignPage.vue?vue&type=script&lang=ts&"
export * from "./DesignPage.vue?vue&type=script&lang=ts&"
import style0 from "./DesignPage.vue?vue&type=style&index=0&id=75b00e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b00e04",
  null
  
)

export default component.exports